import { render, staticRenderFns } from "./DdCustomButtonWithMenu.vue?vue&type=template&id=011f89b6&scoped=true&"
import script from "./DdCustomButtonWithMenu.vue?vue&type=script&lang=js&"
export * from "./DdCustomButtonWithMenu.vue?vue&type=script&lang=js&"
import style0 from "./DdCustomButtonWithMenu.vue?vue&type=style&index=0&id=011f89b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011f89b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VList,VMenu,VTooltip})
